module.exports = __webpack_public_path__ + "static/media/Hall.df8b9687.mp3";